
import { Component, Vue } from "vue-property-decorator";
import { required } from "@/helpers/rules";
import { LoginRequest } from "@/models/utils/login-request.interface";
import { getModule } from "vuex-module-decorators";
import OverlayModule from "@/store/modules/core/overlay.module";
import AuthModule from "@/store/modules/core/auth.module";
import store from "@/store";
const authModule = getModule(AuthModule, store);
const overlayModule = getModule(OverlayModule, store);
import { authenticate } from "@/services/api/authenticate.service";
import SnackBarModule from "@/store/modules/core/snackbar.module";
const snackbarModule = getModule(SnackBarModule, store);

@Component
export default class Login extends Vue {
  private valid = true;
  private showAlert = false;
  private showPassword = false;
  private required = required;
  private errorBlocked = false;

  private form: LoginRequest = {
    username: "",
    password: "",
  };

  async login(): Promise<void> {
    overlayModule.showOverlay();
    this.showAlert = false;
    try {
      this.form.username = this.form.username.toUpperCase(); // REQUIRED OTHERWISE THINGS WILL BREAK!
      let r = await authenticate.login(this.form);
      overlayModule.hideOverlay();
      authModule.login(r.data);
      let idOrder = this.$route.query.idOrder;
      if (idOrder != null) {
        this.$router.push({ path: "/orderDetails?idOrder=" + idOrder });
      } else {
        this.$router.push({ path: "/storage" });
      }
    } catch (e) {
      this.errorBlocked = e.response.status == 403;
      overlayModule.hideOverlay();
      this.showAlert = true;
    }
  }

  private toHomepage(): void {
    this.$router.push({ path: "/home" });
  }

  private async sendEmail(): Promise<void> {
    if (this.form.username.trim() == "") {
      snackbarModule.showSnackbar({
        message: "Username non valido",
        type: "error",
      });
      setTimeout(() => snackbarModule.hideSnackbar(), 5000);
      return;
    }
    overlayModule.showOverlay();
    this.showAlert = false;
    try {
      let r = await authenticate.sendPassword(this.form.username);
      overlayModule.hideOverlay();
      snackbarModule.showSnackbar({
        message: "Email inviata correttamente",
        type: "success",
      });
      setTimeout(() => snackbarModule.hideSnackbar(), 5000);
    } catch (e) {
      overlayModule.hideOverlay();
      snackbarModule.showSnackbar({
        message: "Si è verificato un errore",
        type: "error",
      });
      setTimeout(() => snackbarModule.hideSnackbar(), 5000);
    }
  }
}
